export default {
    apiUrl    : 'https://api.boundly.com',
    apiPrefix : '/',
    amplitudeApiKey: '34d9b3efc474a0c13b2c8844278dc59b',
    amplitudeServerUrl: 'https://a.boundly.com/2/httpapi',
    growthBookClientKey: 'sdk-6z73VOHX1UewKy',
    growthBookApiHost: 'https://cdn.growthbook.io',
    environment: 'production',
    platformUrl: 'https://bound.ly'
};
